<template>
  <v-card>
    <v-toolbar>
      <div class="w-100 d-flex justify-space-between">
        <div class="d-flex align-center font-weight-bold text-lg">
          Não vinculados
        </div>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="100"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="rgb(78, 191, 83)" dark v-bind="attrs" v-on="on">
              Filtrar
            </v-btn>
          </template>

          <v-card class="px-2 py-2">
            <h4 class="mb-1">Filtrar</h4>
            <v-text-field
              class="mb-0"
              outlined
              placeholder="nome"
              v-model="filter.nome"
            />
            <v-text-field
              outlined
              placeholder="código"
              v-model="filter.codigo"
            />
            <v-spacer></v-spacer>
            <v-btn @click="clearFilters" plain>Limpar</v-btn>
          </v-card>
        </v-menu>
      </div>
    </v-toolbar>
    <v-list class="scroll-list">
      <v-list-item v-for="item in itensFiltrados" :key="item.id">
        <v-list-item-content>
          <div class="d-flex list-div">
            <v-list-item-title
              v-text="item.id_centro_custo + ' - ' + item.centro_custo"
            ></v-list-item-title>
            <v-btn icon @click="linkCentroCusto(item)">
              <v-icon color="black">mdi-arrow-right-bold</v-icon>
            </v-btn>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import toast from "@/commom/toast";
import CentroCustoEmpresa from "../../../../services/http/nfeNcm/CentroCustoEmpresa";
export default {
  props: {
    items: {
      type: Array,
    },
    empresaId: {},
  },
  data() {
    return {
      menu: false,
      teste: "",
      filter: {
        nome: "",
        codigo: "",
      },
    };
  },
  methods: {
    async linkCentroCusto(centroCusto) {
      try {
        await CentroCustoEmpresa().store({
          id_empresa: this.empresaId,
          id_centro_custo: centroCusto.id_centro_custo,
          id_grupo_pc: parseInt(centroCusto.id_grupo_pc),
          status: true,
        });
        toast("success", "Sucesso ao vincular: " + centroCusto.id);
        this.$emit("onLinkEnd");
      } catch (e) {
        toast("error", "Não foi possivel vincular");
      }
    },
    clearFilters() {
      this.filter = {
        nome: "",
        codigo: "",
      };
    },
  },
  computed: {
    itensFiltrados() {
      let itens = this.items;

      if (this.filter.nome) {
        itens = itens.filter((item) =>
          item.centro_custo.includes(this.filter.nome)
        );
      }

      if (this.filter.codigo) {
        itens = itens.filter((item) =>
          item.id_centro_custo.includes(this.filter.codigo)
        );
      }
      return itens;
    },
  },
};
</script>
<style scoped>
.list-div {
  border: 1px dashed gray;
  padding-left: 0.5rem;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px;
}
.scroll-list {
  max-height: 65vh !important;
  overflow-y: scroll !important;
}
</style>
